export default __webpack_public_path__ + "static/media/portfolio.91c8803a.mp4";